import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback, useState } from 'react';
import { getBodyFieldValidationMessage, getCcFieldValidationMessage, getEditorText, getFromFieldValidationMessage, getSubjectFieldValidationMessage, getToFieldValidationMessage } from '../../utils/email';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { trackInteraction, trackUsage } from '../../usage-tracker/track';
import { useEmailShareTabContext } from '../../context/EmailShareTabContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const SendEmailButton = ({
  label,
  sendEmail
}) => {
  const {
    connectedEmailsLoading,
    selectedFromValue,
    selectedToValue,
    selectedCcValues,
    subjectValue,
    bodyValue,
    initialSubjectValueLoading,
    sendEmailError,
    updateSendEmailError,
    initialBodyValue,
    initialSubjectValue
  } = useEmailShareTabContext();
  const [isLoading, setIsLoading] = useState(false);
  const maybeTrackSubjectAndBodyChanged = useCallback(() => {
    if (initialSubjectValue !== subjectValue) {
      trackUsage({
        action: 'email subject changed'
      });
    }
    if (getEditorText(initialBodyValue) !== getEditorText(bodyValue)) {
      trackUsage({
        action: 'email body changed'
      });
    }
  }, [initialSubjectValue, subjectValue, initialBodyValue, bodyValue]);
  const handleClick = useCallback(() => {
    trackUsage({
      action: 'click send email button'
    });
    setIsLoading(true);
    updateSendEmailError(null);
    sendEmail({
      fromValue: {
        email: selectedFromValue.email,
        name: selectedFromValue.name
      },
      toContact: selectedToValue,
      ccContacts: selectedCcValues,
      subject: subjectValue,
      body: getEditorText(bodyValue)
    },
    // Success callback
    () => {
      maybeTrackSubjectAndBodyChanged();
      setIsLoading(false);
    },
    // Error callback
    error => {
      updateSendEmailError(error);
      setIsLoading(false);
      trackInteraction({
        action: 'click send email button returned an error'
      });
    });
  }, [bodyValue, selectedCcValues, selectedFromValue, selectedToValue, sendEmail, updateSendEmailError, subjectValue, maybeTrackSubjectAndBodyChanged]);
  const toFieldValidationMessage = getToFieldValidationMessage(selectedToValue, selectedCcValues);
  const ccFieldValidationMessage = getCcFieldValidationMessage(selectedCcValues, selectedToValue);
  const fromFieldValidationMessage = getFromFieldValidationMessage(selectedFromValue);
  const subjectFieldValidationMessage = getSubjectFieldValidationMessage(subjectValue);
  const bodyFieldValidationMessage = getBodyFieldValidationMessage(getEditorText(bodyValue));
  const isEnabled = !connectedEmailsLoading && !initialSubjectValueLoading && !toFieldValidationMessage && !ccFieldValidationMessage && !fromFieldValidationMessage && !subjectFieldValidationMessage && !bodyFieldValidationMessage;
  return /*#__PURE__*/_jsx(LoadingButton, {
    failed: sendEmailError !== null,
    use: "primary",
    responsive: false,
    disabled: !isEnabled,
    onClick: handleClick,
    loading: isLoading,
    "data-test-id": "email-share-tab-send-email-button",
    children: label || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "CommerceToolsUiLib.shareToolModal.emailTab.sendEmailButton.text"
    })
  });
};